import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { resetStep2 } from "../../reducers/Audit";
import {
  createAuditPlanning,
  getAuditReivewDetails,
  getorganization,
  getThemes,
  getSequenceList,
} from "../../api/common";
import SuggestionCard from "../../Components/SuggestionCard";
import { ERROR_MESSAGE } from "../../constants";
import AuditRegistration, {
  AuditData,
} from "../../Containers/CreateAuditPlanning";
import { RootState } from "../../store";
import {
  getTeamsSelectOptions,
  decrypt,
  getSessionStorage,
  getAuditeeSelectOptions,
} from "../../utils";
import PageContainer from "../PageContainer";
import Alert from "../../Components/AlertPopup";

const CreateAuditPlanning = () => {
  const { id } = useParams();
  const staticData = useSelector((state: RootState) => state.staticData);
  const sequenceSteps = useSelector(
    (state: RootState) => state.auditee.step2.sequenceSteps,
  );

  const [auditTypesList, setAuditTypeList] = useState<any>([]);
  const [auditeesList, setAuditeesList] = useState<any>([]);
  const [membersList, setMembersList] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState(
    ERROR_MESSAGE.API_ERROR_MESSAGE,
  );
  const [teamList, setTeamList] = useState<any>([]);
  const [showSuggestionCard, setShowSuggestionCard] = useState(false);
  const [userData, setuserData] = useState<string[]>([]);
  const [getTheme, setTheme] = useState<any>();
  const [getOrganization, setorganization] = useState<any>();
  const [sequence, setSequence] = useState<any>();
  const [suggestions, setSuggestions] = useState<any>([]);
  const [auditUpdatedata, setAuditUpdateData] = useState();
  const [suggestionLoading, setSuggestionLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const encryptedUser = getSessionStorage("user");
  const useForceUpdate = () => {
    const [, setTick] = useState(0);
    const update = useCallback(() => {
      setTick((tick) => tick + 1);
    }, []);
    return update;
  };

  useEffect(() => {
    // Clear sequence steps when component mounts (for Create flow)
    // This ensures a clean state when navigating to Create Audit Plan
    if (!id) {
      dispatch(resetStep2());
    }

    if (encryptedUser) {
      const decryptedData = decrypt(encryptedUser);
      const user = JSON.parse(decryptedData);
      setuserData(user);
    }
    const fetchData = async () => {
      const teamMembersOptions = await getAuditeeSelectOptions();
      const teamOptions = await getTeamsSelectOptions();
      const AuditUpdate = await getAuditReivewDetails(parseInt(id!));
      const Organization = await getorganization();
      const OrgThemes = await getThemes();
      const SequenceList = await getSequenceList();
      console.log(SequenceList);
      setTheme(OrgThemes);
      setorganization(Organization);
      setAuditUpdateData(AuditUpdate);
      setMembersList(teamMembersOptions);
      setTeamList(teamOptions);
      setSequence(SequenceList);
    };

    if (staticData.jobRole && staticData.jobRole.length > 0) {
      setAuditTypeList(staticData.jobRole);
    } else {
      fetchData();
    }
  }, [dispatch, staticData.jobRole, id, encryptedUser]);
  const submitRequests = (auditData: AuditData) => {
    setLoading(true);
    const request = {
      auditLevel: Number(auditData.auditLevel),
      fromDate: auditData.auditeeInfo.startDate.toISOString().split("T")[0],
      toDate: auditData.auditeeInfo.endDate.toISOString().split("T")[0],
      slaTime: auditData.auditSla,
      kickOffMeeting: auditData.kickOffMeeting ?? false,
      auditorMembers: auditData.auditeeInfo.members ?? [],
      auditThemeId: auditData.auditeeInfo.auditThemes ?? [],
      organizationId: auditData.auditeeInfo.organizations ?? [],
      auditSequences:
        Array.isArray(auditData.auditeeInfo.sequencedata) &&
        auditData.auditeeInfo.sequencedata.length > 0
          ? auditData.auditeeInfo.sequencedata
          : sequenceSteps.length > 0
            ? sequenceSteps
            : (sequence.map((item: any, index: any) => ({
                sequenceId: item.sequenceId,
                sequenceOrder: index + 1,
              })) ?? []),
      auditeeOrganizationRequestData:
        auditData.auditeeInfo.organizationDetailsData ?? [],
      escalationDay: auditData.escalationDay,
    };

    createAuditPlanning(request)
      .then((response) => {
        setLoading(false);
        setShowToast(true);
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(ERROR_MESSAGE.API_ERROR_MESSAGE);
        setShowErrorToast(true);
        return;
      });
  };

  return (
    <PageContainer show={false}>
      <div style={{ width: "100%" }}>
        <SuggestionCard
          visible={showSuggestionCard}
          onDismissed={() => {
            setShowSuggestionCard(false);
          }}
          message={suggestions}
          loading={suggestionLoading}
        />
      </div>
      <div style={{ width: "100%" }}>
        <AuditRegistration
          auditUpdatedata={auditUpdatedata}
          userData={userData}
          membersList={membersList}
          auditTypeList={auditTypesList}
          auditeesList={auditeesList}
          loading={loading}
          showToast={showToast}
          getTheme={getTheme}
          sequence={sequence}
          getOrganization={getOrganization}
          onSubmit={(data: AuditData) => {
            submitRequests(data);
          }}
        />
      </div>

      <Alert
        type="error"
        show={showErrorToast}
        onClose={() => setShowErrorToast(false)}
        message={errorMessage}
      />
      <Alert
        show={showToast}
        onClose={() => {
          setShowToast(false);
          dispatch(resetStep2()); // Clear sequence and theme data after successful creation
          navigate("/audit-scheduled");
        }}
        message={"The audit plan has been created successfully!!"}
      />
    </PageContainer>
  );
};

export default CreateAuditPlanning;
